import script from "./lyarea.vue?vue&type=script&setup=true&lang=js"
export * from "./lyarea.vue?vue&type=script&setup=true&lang=js"

import "./lyarea.vue?vue&type=style&index=0&id=915701ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-915701ca"]])

export default __exports__